import { reactive } from 'vue';

// DV: «contact panel open» is a per-user UI setting shared by all devices.
// Left open on the desktop, it covered the chat on the phone every time a
// conversation was opened. ConversationBox suppresses it on small screens for
// the conversation just opened; ConversationSidebar hides itself meanwhile.
export const DV_MOBILE_PANEL_BREAKPOINT = 768;

export const dvMobileContactPanel = reactive({ suppressedChatId: null });

export const isDvSmallScreen = () =>
  typeof window !== 'undefined' &&
  window.innerWidth < DV_MOBILE_PANEL_BREAKPOINT;
